export default __webpack_public_path__ + "static/media/BM_RenderCamera_18_BathroomB+Interior+Light_Scheme+Bathroom.94f7412c.jpg";